var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "time-box" },
      [
        _c(
          "el-card",
          {
            attrs: {
              bordered: false,
              "dis-hover": "",
              padding: 12,
              shadow: "never",
            },
          },
          [
            _c("button-time-picker", {
              on: { dateRangeChange: _vm.dateRangeChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.userStatisticsData.length &&
    _vm.checkPermi(["merchant:user:statistics:top"])
      ? _c(
          "div",
          { staticClass: "mt14" },
          [
            _c("statistics-data-card-list", {
              attrs: { statisticsData: _vm.userStatisticsData },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "statistic-image-box" },
      [
        _c(
          "el-row",
          { staticClass: "mt14", attrs: { gutter: 14 } },
          [
            _vm.checkPermi(["platform:user:statistics:add"])
              ? _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-card",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.newUserLoading,
                            expression: "newUserLoading",
                          },
                        ],
                        attrs: {
                          bordered: false,
                          "dis-hover": "",
                          padding: 12,
                          shadow: "never",
                        },
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.newUserOption,
                            styles: _vm.style,
                            height: "100%",
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.checkPermi(["platform:user:statistics:alive"])
              ? _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-card",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.activeUserLoading,
                            expression: "activeUserLoading",
                          },
                        ],
                        attrs: {
                          bordered: false,
                          "dis-hover": "",
                          padding: 12,
                          shadow: "never",
                        },
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.activeUserOption,
                            styles: _vm.style,
                            height: "100%",
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "mt14", attrs: { gutter: 14 } },
          [
            _vm.checkPermi(["platform:user:statistics:member"])
              ? _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-card",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.boughtUserLoading,
                            expression: "boughtUserLoading",
                          },
                        ],
                        attrs: {
                          bordered: false,
                          "dis-hover": "",
                          padding: 12,
                          shadow: "never",
                        },
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.boughtUserOption,
                            styles: _vm.style,
                            height: "100%",
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.checkPermi(["platform:user:statistics:bought"])
              ? _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-card",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.newMemberLoading,
                            expression: "newMemberLoading",
                          },
                        ],
                        attrs: {
                          bordered: false,
                          "dis-hover": "",
                          padding: 12,
                          shadow: "never",
                        },
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.newMemberOption,
                            styles: _vm.style,
                            height: "100%",
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }